'use client';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { PropsWithChildren, useState } from 'react';

const queryClient = new QueryClient();

export default function ReactQueryProvider({ children }: PropsWithChildren) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
